function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert } from 'antd';
import { Container, Col, Row } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ChangePassword = function ChangePassword(_ref) {
  var user = _ref.user;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormProcessing = _useState6[0],
    setIsFormProcessing = _useState6[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    axios.post(Common.baseApiUrl + 'changeuserpassword', {
      oldpassword: values.oldpassword,
      newpassword: values.newpassword,
      newpassword_confirmation: values.newpassword_confirmation,
      aid: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {}), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: errorMessage,
            showIcon: true
          }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "success",
            message: successMessage,
            showIcon: true
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            form: form,
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "oldpassword",
              label: "Ancien mot de passe",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input.Password, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "newpassword",
              label: "Nouveau mot de passe",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input.Password, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "newpassword_confirmation",
              label: "Confirmer mot de passe",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input.Password, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                loading: isFormProcessing,
                htmlType: "submit",
                children: "Changer"
              })
            })]
          })]
        })
      })
    })]
  });
};
export default ChangePassword;